module.exports = __webpack_public_path__ + "static/media/menu-white.934d5cdf.svg";